export class Feature {

    /**
   * @returns {import("../types").DialogState}
  */
    static actionDialogState(t, data) {
        return {
            visible: true,
            activeStep: 0,
            nombre_servicio: data.nombre_servicio,
            resolveBody: (_, props) => {
                return { url: `/marketplace/${props.farmId}/enable-feature`, body: { feature: data.otras_configuraciones.key } };
            },
            data: {},
            steps: [],
        };
    }
}
